import React from 'react';
import { Card, Statistic, Typography, Button, Space } from 'antd';
import { 
  FileOutlined, 
  CloudUploadOutlined, 
  DownloadOutlined, 
  ShareAltOutlined,
  FolderOpenOutlined,
  PlusCircleOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const { Title, Text, Paragraph } = Typography;

export const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div>
      <Title level={2} style={{ marginBottom: '24px' }}>
        {user?.is_staff ? 'Site Administration' : `Welcome, ${user?.first_name || user?.username}!`}
      </Title>
      
      {user?.is_staff && (
        <div style={{ display: 'flex', gap: '16px', marginBottom: '32px', flexWrap: 'wrap' }}>
          <Card style={{ flex: '1', minWidth: '220px' }}><Statistic title="Total Files" value={0} prefix={<FileOutlined />} /></Card>
          <Card style={{ flex: '1', minWidth: '220px' }}><Statistic title="Storage Used" value="0" suffix="MB" prefix={<CloudUploadOutlined />} /></Card>
          <Card style={{ flex: '1', minWidth: '220px' }}><Statistic title="Downloads" value={0} prefix={<DownloadOutlined />} /></Card>
          <Card style={{ flex: '1', minWidth: '220px' }}><Statistic title="Share Links" value={0} prefix={<ShareAltOutlined />} /></Card>
        </div>
      )}

      {!user?.is_staff && (
        <Paragraph style={{ marginBottom: '32px' }}>
            This is your personal dashboard. Use the menu on the left to navigate to the available sections.
        </Paragraph>
      )}

      {/* Management Sections using Flexbox */}
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
        {user?.is_staff && (
          <Card title="File Management" style={{ flex: '1', minWidth: '300px' }}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <Text strong><FolderOpenOutlined style={{ marginRight: 8 }} />Manage Files</Text>
                  <br />
                  <Text type="secondary">View, edit, and manage all your uploaded files.</Text>
                </div>
                <Button onClick={() => navigate('/files')}>Manage</Button>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <Text strong><PlusCircleOutlined style={{ marginRight: 8 }} />Upload New File</Text>
                  <br />
                  <Text type="secondary">Add a new file to your S3 bucket.</Text>
                </div>
                <Button type="primary" onClick={() => navigate('/files')}>Upload</Button>
              </div>
            </Space>
          </Card>
        )}
        
        {!user?.groups?.includes('Guests') && (
          <Card title="Account Management" style={{ flex: '1', minWidth: '300px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Text strong><SettingOutlined style={{ marginRight: 8 }} />Manage Your Profile</Text>
                <br />
                <Text type="secondary">Change your password and update personal information.</Text>
              </div>
              <Button onClick={() => navigate('/settings')}>Edit Profile</Button>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}; 